import { compose, withProps, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { expandQuickAppointmentButton } from 'helpers/custom-events'
import {
  getCurrentStore,
  getCurrentStorePhoneNumber,
  getCurrentStoreEnableAppointmentFlag
} from 'selectors/getCurrentStore'
import { showAppointmentUnsupportedModal } from 'components/Header/components/MakeAnAppointment/components/AppointmentUnsupportedModal/actions'
import { createAccountAction } from './actions'
import BOTAccessYourAppointmentInfo from './BOTAccessYourAppointmentInfo'


const mapStateToProps = state => ({
  myStoreExists: Boolean(getCurrentStore(state)),
  myStorePhoneNumber: getCurrentStorePhoneNumber(state),
  myStoreAppointmentEnableFlag: getCurrentStoreEnableAppointmentFlag(state)
})

export default compose(
  withType({ type: 'BOTAccessYourAppointmentInfo' }),
  connect(mapStateToProps, { createAccountAction, showAppointmentUnsupportedModal }),
  withProps(({
    myStoreExists,
    myStorePhoneNumber,
    myStoreAppointmentEnableFlag,
    showAppointmentUnsupportedModal
  }) => ({
    makeAnAppointmentOnClickHandler: myStoreExists && !myStoreAppointmentEnableFlag ?
      () => showAppointmentUnsupportedModal({ phoneNumber: myStorePhoneNumber }) :
      expandQuickAppointmentButton
  })),
  withHandlers({
    createAccountActionHandler: ({ createAccountAction, createAccountLink }) => () =>
      createAccountAction(createAccountLink)
  })
)(BOTAccessYourAppointmentInfo)
